<template>
    <div class="purchase-block">
        <h3>Purchase Now</h3>
<!--        <div class="payment-method-picker">-->
<!--            <div class="form-check">-->
<!--                <input class="form-check-input" type="radio" name="paymentMethod" value="PayPal">-->
<!--                <div class="d-flex">-->
<!--                    <label class="form-check-label text-dark">-->
<!--                        PayPal-->
<!--                    </label>-->
<!--                    <img class="my-2 mx-1" src="/assets/images/logo/third-party/paypal.png" height="32" alt="PayPal">-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="form-check">-->
<!--                <input class="form-check-input" type="radio" name="paymentMethod" value="Stripe">-->
<!--                <div class="d-flex">-->
<!--                    <label class="form-check-label text-dark">-->
<!--                        Stripe-->
<!--                    </label>-->
<!--                    <img class="my-2 mx-1" src="/assets/images/logo/third-party/stripe.png" height="32" alt="Stripe">-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="form-check">-->
<!--                <input class="form-check-input" type="radio" name="paymentMethod" value="CreditCard" checked>-->

<!--                <div class="d-flex">-->
<!--                    <label class="form-check-label text-dark">-->
<!--                        Credit Card-->
<!--                    </label>-->
<!--                    <img class="my-2 mx-1" src="/assets/images/logo/third-party/american-express.png" height="32" alt="American Express">-->
<!--                    <img class="my-2 mx-1" src="/assets/images/logo/third-party/maestro.png" height="32" alt="Maestro">-->
<!--                    <img class="my-2 mx-1" src="/assets/images/logo/third-party/mastercard.png" height="32" alt="Mastercard">-->
<!--                    <img class="my-2 mx-1" src="/assets/images/logo/third-party/visa.png" height="32" alt="Visa">-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="payment-container">
            <PaymentCreditCard>
                <button class="btn btn-primary w-100">Purchase</button>
            </PaymentCreditCard>
        </div>
        <div class="confirmation">
            <FormCheck name="agreement">I have read and understand <a href="https://bikerent.nyc/customer-service" class="text-decoration-underline">Privacy</a> and <a href="#" class="text-decoration-underline">Cookies Policy*</a></FormCheck>
        </div>
    </div>
</template>

<script>
export default {
    name: "PurchaseBlock"
}
</script>

<style scoped>

</style>
